import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Image } from '@/design-system/atoms/Image';

import styles from './Container.module.scss';

/**
 * Card Container Component
 * @param {object} props
 * @param {object} props.ref - React ref object
 * @param {object} props.children - Child components
 * @param {string} props.className - Additional class name
 * @param {object} props.image - Image object
 * @param {object} props.otherProps - Additional props
 */
const Container = React.forwardRef((props, ref) => {
    const { children, className, image, ...otherProps } = props;

    return (
        <div ref={ref} className={classnames(styles['wrapper'], className)} {...otherProps}>
            <div className={styles['container']}>{children}</div>
            {image && (
                <Image
                    {...image}
                    className={styles['image']}
                    roundedCorners
                    defaultAspectRatio="2/3"
                />
            )}
        </div>
    );
});

Container.displayName = 'Container';

Container.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    image: PropTypes.shape({
        defaultImgSrc: PropTypes.string,
        alt: PropTypes.string,
    }),
};

export default Container;
